"use client";

import { Zap } from "lucide-react";

import SchoolTag from "@/components/shared/school/school-details/school-tag";
import { schoolQuickApplyTag } from "@/lib/data-test-ids/schools.data-test-ids";

export default function SchoolQuickApplyTag() {
  return (
    <SchoolTag
      IconComponent={Zap}
      className="text-brand-purple"
      title="Quick Apply"
      tooltip="Uses your Nimble profile to pre-fill your application and apply faster"
      dataTestid={schoolQuickApplyTag.QUICK_APPLY_TAG_ELEMENT}
    />
  );
}
